import { autoinject, computedFrom } from 'aurelia-framework';
import { Store } from "aurelia-store";
import { IState } from "../../../store/state";
import { Device } from "../../../models/device";
import { applicationLogger } from "../../../logging/logger";
import { TemperatureBaseDevice } from "./temperature-base-device";
import { StatusColors } from "../../common/status-colors";
import { createDarkText, createLightText } from "../../common/common-functions";

import { Api } from "../../../services/api";
import { I18N } from "aurelia-i18n";

@autoinject
export class MilesiteWTS506WeatherStation extends TemperatureBaseDevice {

	constructor(store: Store<IState>, api: Api, i18n: I18N) {
		super(store, api, i18n);
	}

	//{
	//   "protocolVersion": 2,
	//   "deviceId": 5275, 
	//   "solarRadiation": 0, 
	//   "precipitation": 0, 
	//   "lightningStrikeCount": 0, 
	//   "lightningAverageDistance": 0, 
	//   "windSpeed": 0.08, "windDirection": 176.2, "maximumWindSpeed": 0.09, 
	//   "airTemperature": 22.1, 
	//   "vaporPressure": 0.81, 
	//   "atmosphericPressure": 90.67, 
	//   "relativeHumidity": 30.5, 
	//   "sensorTemperatureInternal": 22, 
	//   "xOrientationAngle": 1, "yOrientationAngle": 2.2, "compassHeading": 0, 
	//   "northWindSpeed": -0.08, "eastWindSpeed": 0, 
	//   "batteryVoltage": 2.905, 
	//   "timestamp": "2020-04-24T11:18:21", 
	//    "rssi": -28
	// }

	activate(device: Device) {
		this.device = device;
	}

	attached() {
		if (this.tooltip) {
			//this.tooltip.position = "bottom";
			this.tooltip.html = this.buildToolTip();
		}

	}

	unbind() {
		this.unsubscribe
	}

	//@computedFrom('device.data')
	//get solarRadiation(): string {
	//	if (this.device.data === undefined || this.device.data.solarRadiation === undefined) {
	//		return null;
	//	}
	//	return `${this.device.data.solarRadiation} W/m² `;
	//}

	//@computedFrom('device.data')
	//get precipitation(): string {
	//	if (this.device.data === undefined || this.device.data.precipitation === undefined) {
	//		return null;
	//	}
	//	return `${this.device.data.precipitation} mm/h  `;
	//}

	/*
		
		precipitation
		airTemperature
		vaporPressure
		atmosphericPressure
		relativeHumidity

		windSpeed
		windDirection
		maximumWindSpeed
		northWindSpeed
		eastWindSpeed

		lightningStrikeCount
		lightningAverageDistance

		compassHeading
		xOrientationAngle
		yOrientationAngle
	*/
}